import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  headerWrapper: {
    paddingBottom: theme.spacings.lg,
  },
  headerText: {
    fontSize: theme.fontSizes.xl,
  },
  errorWrapper: {
    padding: theme.spacings.sm,
  },
  errorText: {
    fontWeight: '600',
    color: theme.colors.red,
    fontSize: theme.fontSizes.lg,
  },
  buttonRow: {
    flexDirection: 'row',
    columnGap: theme.spacings.md,
    marginTop: theme.spacings.xs,
  },
  flex1: {
    flex: 1,
  },
});
